import React, { useState } from 'react';
import PlanDetailsModal from '../subscription/PlanDetailsModal';
import SubscriptionPlans from '../subscription/SubscriptionPlans';
import { FiCheckCircle } from "react-icons/fi";
import SubscriptionBenefits from '../subscription/SubscriptionBenefits';
import PaymentSection from '../subscription/PaymentSection';
import PrimeSubscriptionHero from '../subscription/PrimeSubscriptionHero';

const PrimeSubscription = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const openPlanDetails = (plan) => {
        setSelectedPlan(plan);
        setIsModalOpen(true);
    };

    const plans = [
        {
            title: "Monthly Subscription",
            validity: "31 Days",
            price: 99,
            oldPrice: 599,
            discount: "83%",
            features: [
                "70,000+ Mock Tests",
                "Unlimited Practice Questions",
                "17,000+ Previous Year Papers",
                "Unlimited Re-attempt Mode"
            ]
        },
        {
            title: "Yearly Subscription",
            validity: "365 Days",
            price: 799,
            oldPrice: 4599,
            discount: "83%",
            features: [
                "All Monthly Features",
                "Unlimited Pro Live Tests",
                "Priority Support",
                "Personalized Study Plan"
            ]
        },
        {
            title: "Yearly Prime Subscription",
            validity: "365 Days",
            price: 799,
            oldPrice: 6499,
            discount: "88%",
            features: [
                "All Monthly Features",
                "Unlimited Pro Live Tests",
                "Priority Support",
                "Personalized Study Plan",
                "Advanced Analytics"
            ]
        }
    ];

    return (
        <div className="w-full max-w-[1400px] mx-auto lg:px-6 py-6 font-inter bg-[#F8F9FA]">
            <PrimeSubscriptionHero />
            {/* <SubscriptionPlans onPlanClick={openPlanDetails} /> */}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16 items-stretch">
                {plans.map((p, i) => (
                    <div key={p._id || i} className="h-full flex">
                        <div
                            onClick={() => openPlanDetails(p)}
                            className={`bg-white rounded-[10px] p-6 md:p-8 flex flex-col items-center flex-1 shadow-sm transition-all border cursor-pointer
      ${p.isActive
                                    ? "border-[#4096F6] border-2 relative lg:scale-105 z-10"
                                    : "border-[#E0E0E0]"
                                }`}
                        >
                            <h3 className="text-[20px] tracking-tight font-[600] text-[#000000] mb-1 font-inter text-center">
                                {p.title}
                            </h3>

                            <p className="text-[13px] md:text-[16px] text-[#000000] mb-6 font-[500] font-inter text-center">
                                Valid for {p.validity}
                            </p>

                            <div className="flex flex-wrap justify-center items-center gap-2 md:gap-3 mb-6">
                                <span className="text-[28px] font-[600] text-[#4096F6] font-inter">
                                    ₹{p.price}
                                </span>
                                <span className="text-[16px] md:text-[21px] text-[#33333380] line-through font-inter">
                                    ₹{p.oldPrice}
                                </span>
                                <span className="bg-[#DAB820] text-white text-[10px] md:text-[16px] font-[500] px-3 md:px-4 py-[8px] rounded-full uppercase font-inter whitespace-nowrap">
                                    {p.discount} OFF
                                </span>
                            </div>

                            <div className="w-full h-[1.5px] bg-[#333] mb-6 md:mb-8"></div>

                            <ul className="w-full space-y-3 md:space-y-4 mb-8 md:mb-10">
                                {p.features.map((feature, i) => (
                                    <li
                                        key={i}
                                        className="flex items-start gap-3 pb-2 text-[13px] md:text-[18px] text-[#000000] font-[500] border-b border-dashed border-[#000000] last:border-0 font-inter text-left leading-tight"
                                    >
                                        <FiCheckCircle className="text-[#21C11E] text-[18px] shrink-0 mt-0.5" />
                                        {feature}
                                    </li>
                                ))}
                            </ul>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                className="w-full bg-[#4096F6] hover:bg-[#2563EB] text-white text-[18px] tracking-tight py-3 transition-colors mt-auto font-inter font-[500] shadow-sm cursor-pointer active:scale-95"
                            >
                                Select {p.title.split(" ")[0]} Plan
                            </button>
                        </div>

                    </div>
                ))}
            </div>
            <SubscriptionBenefits />
            <PaymentSection />
            <PlanDetailsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                plan={selectedPlan}
            />

            <footer className="mt-20 text-center text-[12px] tracking-tight md:text-[18px] text-[#333333] font-inter border-t border-[#333333] pt-10">
                <p>   © 2026 BaapBola. All rights reserved.</p>
                <p>
                    Prime Subscription subscriptions are non-refundable once cancelled. Cancel anytime from account settings.
                </p>

            </footer>
        </div>
    );
};

export default PrimeSubscription;